module.exports = __webpack_public_path__ + "img/Ic_Union.c49dbaca.svg";